import { render, staticRenderFns } from "./TheoryPracticeWorkshopLessons.vue?vue&type=template&id=6cf782a6&scoped=true&"
import script from "./TheoryPracticeWorkshopLessons.vue?vue&type=script&lang=js&"
export * from "./TheoryPracticeWorkshopLessons.vue?vue&type=script&lang=js&"
import style0 from "./TheoryPracticeWorkshopLessons.vue?vue&type=style&index=0&id=6cf782a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf782a6",
  null
  
)

export default component.exports